import React from 'react';
import { Row, Col, CardBody, Form, CustomInput, FormGroup } from 'reactstrap';
import { Carousel } from 'react-responsive-carousel';
import { DEFAULT_IMAGE } from '../../../configs';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import * as QUESTION from '../../../constants/questions';
import { alphabet } from '../../../static/utils';
import CustomCarousel from '../../elements/Carousel/Carousel';
import MultipleQuestionItem from '../../elements/MultipleQuestionItem/MultipleQuestionItem';

import './PostCard.css';

export const PostCardBody = ({
    post,
    onMultipleClick,
    isReview,
    activeTabPosts,
    showModalImage,
}) => {
    const showCarousel = post && post.media && post.media.length > 0;
    return (
        <CardBody className="p-0">
            <Row className="card-body-content">
                {showCarousel && (
                    <Col md={5}>
                        {/*<Carousel*/}
                        {/*    showThumbs={false}*/}
                        {/*>*/}
                        {/*    {post.media && post.media.map((media, index) => {*/}
                        {/*        return (*/}
                        {/*            <div key={index}>*/}
                        {/*                <img src={media.downloadMediaUrl}/>*/}
                        {/*                <p className="legend">Legend 1</p>*/}
                        {/*            </div>*/}
                        {/*        )*/}
                        {/*    })}*/}
                        {/*</Carousel>*/}

                        <CustomCarousel
                            showModalImage={showModalImage}
                            postImages={post.media.length > 0 ? post.media : [DEFAULT_IMAGE]}
                        />
                    </Col>
                )}
                <Col md={showCarousel ? 7 : 12}>
                    <div className={'CardBodyText'}>
                        <h5>{post.title}</h5>
                        {(post.question.type === QUESTION.OPEN ||
                            post.question.type === QUESTION.YES_NO) && <p>{post.description}</p>}
                        {post.question.type === QUESTION.MULTIPLE && (
                            <div>
                                {
                                    <Form>
                                        <FormGroup>
                                            {post.question &&
                                                post.question.questions.map((question, index) => (
                                                    <MultipleQuestionItem
                                                        activeTabPosts={activeTabPosts}
                                                        key={index}
                                                        index={index}
                                                        question={question}
                                                        onMultipleClick={onMultipleClick}
                                                        isReview={isReview}
                                                    />
                                                ))}
                                        </FormGroup>
                                    </Form>
                                }
                            </div>
                        )}
                    </div>
                </Col>
            </Row>
        </CardBody>
    );
};
